import { EVENTS } from "../../../../js/constants";

class MainNavigation {
  /**
   * @param {HTMLElement} element - the main-navigation element
   */
  constructor(element) {
    this.element = element;
    this.activeClass = "is-active";

    this.mobileOpenButton = element.querySelector(".js-MainNavigation-button");
    this.items = [...element.querySelectorAll(".js-MainNavigation-label")];

    this.isMobileMenuOpen = false;
    this.clickOutsideEnabled = false;

    this._hideMenuOnClickOutside = this._hideMenuOnClickOutside.bind(this);

    this._bind();
  }

  /**
   * bind
   *
   * @private
   */
  _bind() {
    this.items.forEach((item) => {
      item.addEventListener("click", () => {
        this._handlesClickOnMenuItem(item);
      });
    });

    this.mobileOpenButton.addEventListener("click", () =>
      this.isMobileMenuOpen ? this._closeMobileMenu() : this._openMobileMenu()
    );

    this._bindClickOutside();
  }

  /**
   * handles click on menu item
   *
   * @private
   * @param {HTMLElement} item
   */
  _handlesClickOnMenuItem(item) {
    const activeItem = this.items.find((i) =>
      i.classList.contains(this.activeClass)
    );

    this._removeActiveMenuItems();

    if (activeItem !== item) {
      item.classList.add(this.activeClass);
    }
  }

  /**
   * adds click event listener to the click on the document
   *
   * @private
   */
  _bindClickOutside() {
    if (!this.clickOutsideEnabled) {
      document.addEventListener("click", this._hideMenuOnClickOutside);
      this.clickOutsideEnabled = true;
    }
  }

  /**
   * opens mobile menu
   *
   * @private
   */
  _openMobileMenu() {
    this.element.dispatchEvent(
      new CustomEvent(EVENTS.MENU_OPEN, { bubbles: true })
    );
    this.element.classList.add(this.activeClass);
    this.isMobileMenuOpen = true;
  }

  /**
   * closes mobile menu
   *
   * @private
   */
  _closeMobileMenu() {
    this.element.dispatchEvent(
      new CustomEvent(EVENTS.MENU_CLOSE, { bubbles: true })
    );
    this.element.classList.remove(this.activeClass);
    this.isMobileMenuOpen = false;
  }

  /**
   * removes activeClass from any active elements inside the menu
   *
   * @private
   */
  _removeActiveMenuItems() {
    const activeItems = [
      ...this.element.querySelectorAll(`.${this.activeClass}`),
    ];

    activeItems.forEach((item) => {
      item.classList.remove(this.activeClass);
    });
  }

  /**
   * hides menu by clicking outside of navigation or burger button
   *
   * @private
   * @param {object} event - event
   */
  _hideMenuOnClickOutside(event) {
    const isClickOutside =
      !event.target.closest(".js-MainNavigation-button") &&
      !event.target.closest(".js-MainNavigation-nav");

    const activeItems = this.items.filter((item) =>
      item.classList.contains(this.activeClass)
    );

    const menuIsActive = this.isMobileMenuOpen || activeItems.length;

    if (isClickOutside && menuIsActive) {
      this._removeActiveMenuItems();

      if (this.isMobileMenuOpen) {
        this._closeMobileMenu();
      }
    }
  }
}

export default MainNavigation;
